var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPmt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 18,
    height: 18,
    fill: "rgba(52,122,240,0.1)",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-2",
    "data-name": "Edit",
    transform: "translate(4.5 4.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M116.213.655a1.345,1.345,0,0,0-1.9,0l-5.332,5.332a.3.3,0,0,0-.077.132l-.7,2.531a.3.3,0,0,0,.368.368l2.531-.7a.3.3,0,0,0,.132-.077l5.332-5.332a1.346,1.346,0,0,0,0-1.9ZM109.63,6.181l4.364-4.364L115.4,3.224l-4.364,4.364Zm-.281.564,1.124,1.124-1.555.431Zm6.792-4.26-.317.317-1.407-1.407.317-.317a.747.747,0,0,1,1.057,0l.351.351A.748.748,0,0,1,116.141,2.485Zm0,0",
    transform: "translate(-108.19 -0.261)",
    fill: "#347af0",
    stroke: "#347af0",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPmt);
export default __webpack_public_path__ + "static/media/editPmt.4b57d63cf581fea557adfbb217bdef64.svg";
export { ForwardRef as ReactComponent };